import React, { Component } from 'react';
import DataTable from 'Components/Table/dataTable';
import Pagination from 'Components/Pagination/index';
import { ReactComponent as Add } from 'assets/images/svg/add.svg';
import formUrlParams, { calculatePaginationPage } from 'Helpers/urlform';
import { cloneDeep } from 'lodash';
import SearchBar from 'Components/Common/SearchBar';
import { ReactComponent as Search } from 'assets/images/svg/search-icon.svg';
import { ReactComponent as Close } from 'assets/images/svg/Popclose.svg';

class ExistedTeamUsers extends Component {
    constructor(props) {
        super(props);
        const pageLimit = 5;
        const model = {
            headers: [
                {
                    title: 'Name',
                    combineapidata: [ 'name', 'image' ],
                    accessor: 'name' /* API response */,
                    cell: {
                        type: 'image-with-name',
                    },
                    tooltip: true,
                    chooseOption: {
                        name: 'nameSearch' /* API param name */,
                        Component: 'Search',
                        dispatchFunction: this.handleSearch,
                    }
                },
                {
                    title: 'Email',
                    accessor: 'emailId',
                    tooltip: true,
                    chooseOption: {
                        name: 'emailSearch' /* API param name */,
                        Component: 'Search',
                        dispatchFunction: this.handleSearch,
                    }
                },
                {
                    title: 'Action',
                    accessor: 'id',
                    cell: (rowDetails) => {
                        const { index, rowIdx, ...rest } = rowDetails;
                        return (
                        <td key={ index } data-row={ rowIdx } className='action'>
                            <span className='btn btn_seconday'
                            onClick={ (event) => this.handleRemoveTeamMembers(rest, event) }
                            >
                            Remove User
                            </span>
                        </td>
                        );
                    }
                },
            ],
            page: 1,
            pageLimit: 10,
            nameSearch: '',
            emailSearch: ''
        };
        this.state = model;

        this.totalRecords = props.teamMembers.length;
    }

    handleRemoveTeamMembers = (rest, event) => {
        event.preventDefault();
        this.props.handleRemoveTeamMembers(rest);
        const paginaionData = calculatePaginationPage( 
            [ { id:'page', value: this.state.page }, { id:'size', value: this.state.pageLimit } ],
            this.totalRecords,
            this.state.page,
            1
        );

        const pageObj = paginaionData.find(search => search.id === 'page');
        if(pageObj?.value){
            this.setState({ page: pageObj.value });
        }
        const sizeObj = paginaionData.find(search => search.id === 'size');
        if(sizeObj?.value){
            this.setState({ pageLimit: sizeObj.value });
        }
    }

    getPaginatedRecord = (teamMembers) => {
        const clonedTeamMembers = cloneDeep(teamMembers);
        const pageLimit = this.state.pageLimit;
        const page = this.state.page;
        let start = 0;
        if(page > 1){
            start = parseInt(pageLimit) * (parseInt(page) - 1);
        }
        const end = parseInt(start) + parseInt(pageLimit);
        return clonedTeamMembers.slice(start, end)
    }

    handleExistUsersList = () => {
        const { teamMembers } = this.props;
        let updatedTeamMembers = cloneDeep(teamMembers);
        if(this.state.nameSearch || this.state.emailSearch){
            updatedTeamMembers = updatedTeamMembers.filter(member => {
                let query = false;
                if(this.state.nameSearch){
                    query = member.name?.toLowerCase()?.indexOf(this.state.nameSearch.toLowerCase()) >= 0;
                }

                if(this.state.emailSearch){
                    query = member.emailId?.toLowerCase()?.indexOf(this.state.emailSearch.toLowerCase()) >= 0;
                }
                return query;
            });
        }
        return { totalRecords: updatedTeamMembers.length, records: this.getPaginatedRecord(updatedTeamMembers) };
    }

    formUrlParams = (name, value, rest) => {
        this.setState({ [ name ]: value });
    }

    setPageLimit = (name, value) => {
        this.formUrlParams('pageLimit', value);
        this.formUrlParams('page', 1);
    };

    handleSearch = (event) => {
        const { name, value } = event.target;
        this.setState({ [ name ]: value, page: 1 });
    }

    render(){
        const usersListObj = this.handleExistUsersList();
        const usersList = usersListObj.records;
        this.totalRecords = usersListObj.totalRecords;

        return(
            <div className='responsive-table ctTableBox'>
                <div className='heading-block gap-10'>
                  <h5>users ( { this.props.teamMembers.length } )</h5>
                  <button class="btn btn_primary" onClick={ () => this.props.toggleAddTeamUsersPopup() }><Add /> Add User</button>
                </div>
                <DataTable
                  className='data-table'
                  keyField='id'
                  headers={ this.state.headers }
                  data={ usersList }
                  noData='No records!'
                />
                { !this.props.addTeamUsersPopup && <Pagination
                  handleClick={ this.formUrlParams }
                  totalRecords={ this.totalRecords }
                  initialPage={ this.state.page }
                  setPageLimit={ this.setPageLimit }
                  pageLimit={ this.state.pageLimit }
                />}
            </div>
        )
    }
}

export default ExistedTeamUsers;